import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { toList } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { PurchaseOrder } from '../state/types'

export const usePurchaseLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllPurchases = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.PURCHASE_ORDERS, options)
            return response.dataTypes as PurchaseOrder[]
        }

        const loadPurchase = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.PURCHASE_ORDERS, id, dbRequest) as Promise<O<PurchaseOrder>>
        }

        const loadPurchases = (ids: string[]) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.PURCHASE_ORDERS, ids) as Promise<PurchaseOrder[]>
        }

        const loadBranchPurchases = async (deliveryBranchId: string) => {
            const { loadFiltered, hasLoaded, addToLoaded } = loaders(companyId)
            const params = { deliveryBranchId }
            const purchases = await loadFiltered(TableName.PURCHASE_ORDERS, !hasLoaded(TableName.PURCHASE_ORDERS), params) as PurchaseOrder[]
            addToLoaded(TableName.PURCHASE_ORDERS)
            return purchases
        }

        const loadPurchasesWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.PURCHASE_ORDERS, dbRequest, undefined, undefined, toList(propName)) as Promise<PurchaseOrder[]>
        }

        const countPurchases = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.PURCHASE_ORDERS, options)
        }

        return {
            loadAllPurchases,
            loadPurchase,
            loadPurchases,
            loadBranchPurchases,
            loadPurchasesWithProp,
            countPurchases
        }
    }
}
